export const BIG_BLUE_MAP_PANES = {
  restricted: "restrictedPane",
  markers: "markersPane",
} as const;

export type BigBlueMapPaneName =
  (typeof BIG_BLUE_MAP_PANES)[keyof typeof BIG_BLUE_MAP_PANES];

export const BIG_BLUE_MAP_PANE_Z_INDEX: Record<BigBlueMapPaneName, number> = {
  [BIG_BLUE_MAP_PANES.restricted]: 410,
  [BIG_BLUE_MAP_PANES.markers]: 520,
};

export function ensureBigBlueMapPanes(map: any) {
  if (!map?.getPane || !map?.createPane) return;

  (Object.values(BIG_BLUE_MAP_PANES) as BigBlueMapPaneName[]).forEach(
    (paneName) => {
      const pane = map.getPane(paneName) || map.createPane(paneName);
      if (!pane?.style) return;
      pane.style.zIndex = String(BIG_BLUE_MAP_PANE_Z_INDEX[paneName]);
    },
  );
}

export function getBigBlueMapPane(
  map: any,
  paneName: BigBlueMapPaneName,
): HTMLElement | undefined {
  return map?.getPane?.(paneName) as HTMLElement | undefined;
}

export function isBigBlueMapPaneConnected(
  map: any,
  paneName: BigBlueMapPaneName,
) {
  const pane = getBigBlueMapPane(map, paneName);
  return Boolean(pane && pane.isConnected);
}
